import { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import { AuthLayout, MainLayout } from '@components/layouts';

import { ROUTES } from '@constants/routes';

import PageForbidden from '@pages/forbidden';

/* eslint-disable react-refresh/only-export-components */
const PageAuth = lazy(async () => await import('@pages/auth'));
const ErrorPage = lazy(async () => await import('@pages/error'));
const PageTrains = lazy(async () => await import('@pages/trains'));
const PageWagonGroups = lazy(async () => await import('@pages/carriageGroup'));
const PageDictionaries = lazy(async () => await import('@pages/dictionaries'));
const PageAdmin = lazy(async () => await import('@pages/admin'));
const PageGeneral = lazy(async () => await import('@pages/main'));
const PageTrailedDirectGroups = lazy(
  async () => await import('@pages/trailedDirectGroups'),
);
const PageSummaryCalculations = lazy(
  async () => await import('@pages/summaryCalculations'),
);
const PageIndicators = lazy(async () => await import('@pages/indicators'));
const PageHelp = lazy(async () => await import('@pages/help'));
const PageLogout = lazy(async () => await import('@pages/logout'));
const PageProfile = lazy(async () => await import('@pages/profile'));
const PageLocomotiveArea = lazy(
  async () => await import('@pages/locomotiveArea'),
);
const PageControlTransportParameters = lazy(
  async () => await import('@pages/control'),
);

export const router = createBrowserRouter([
  {
    element: <MainLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: `${ROUTES.TRAINS}/*`,
        element: <PageTrains />,
      },
      {
        path: `${ROUTES.LOCOMOTIVE_AREA}/*`,
        element: <PageLocomotiveArea />,
      },
      {
        path: `${ROUTES.CARRIAGE_GROUPS}/*`,
        element: <PageWagonGroups />,
      },
      {
        path: `${ROUTES.TRAILED_DIRECT_GROUPS}/*`,
        element: <PageTrailedDirectGroups />,
      },
      {
        path: `${ROUTES.DICTIONARIES}/*`,
        element: <PageDictionaries />,
      },
      {
        path: `${ROUTES.ADMIN}/*`,
        element: <PageAdmin />,
      },
      {
        path: `${ROUTES.SUMMARY_CALCULATIONS}/*`,
        element: <PageSummaryCalculations />,
      },
      {
        path: `${ROUTES.INDICATORS}/*`,
        element: <PageIndicators />,
      },
      {
        path: `${ROUTES.GENERAL}/*`,
        element: <PageGeneral />,
      },
      {
        path: `${ROUTES.HELP}/*`,
        element: <PageHelp />,
      },
      {
        path: `${ROUTES.PROFILE}/*`,
        element: <PageProfile />,
      },
      {
        path: `${ROUTES.FORBIDDEN}`,
        element: <PageForbidden />,
      },
      {
        path: `${ROUTES.CONTROL_TRANSPORT_PARAMETER}/*`,
        element: <PageControlTransportParameters />,
      },
      {
        path: '*',
        element: <Navigate to={ROUTES.GENERAL} />,
      },
    ],
  },
  {
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: `${ROUTES.SIGN_IN}/*`,
        element: <PageAuth />,
      },
    ],
  },
  {
    element: <AuthLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: `${ROUTES.LOG_OUT}`,
        element: <PageLogout />,
      },
    ],
  },
]);
